import { useState, useEffect } from 'react';
import { apiClient } from '../../services/apiClient';
import './StatusBar.css';

export default function StatusBar() {
    const [status, setStatus] = useState({
        backend: 'checking',
        database: 'checking',
        ollama: 'checking'
    });

    const fetchStatus = async () => {
        try {
            const response = await apiClient.request('/api/metrics/system/status');
            // Set the returned status or default to offline if something is missing
            setStatus({
                backend: response.backend || 'offline',
                database: response.database || 'offline',
                ollama: response.ollama || 'offline'
            });
        } catch (error) {
            console.error('Failed to fetch system status:', error);
            setStatus({
                backend: 'offline',
                database: 'offline',
                ollama: 'offline'
            });
        }
    };

    useEffect(() => {
        fetchStatus();
        // Poll every 30 seconds
        const interval = setInterval(fetchStatus, 30000);
        return () => clearInterval(interval);
    }, []);

    const getStatusIcon = (serviceStatus) => {
        switch (serviceStatus) {
            case 'online':
                return <span className="status-dot status-online"></span>;
            case 'offline':
                return <span className="status-dot status-offline"></span>;
            default:
                return <span className="status-dot status-checking"></span>;
        }
    };

    return (
        <div className="status-bar-wrapper">
            <div className="status-bar">
                <div className="status-item" title={`Backend: ${status.backend}`}>
                    <span className="status-label">API</span>
                    {getStatusIcon(status.backend)}
                </div>
                <div className="status-item" title={`Database: ${status.database}`}>
                    <span className="status-label">DB</span>
                    {getStatusIcon(status.database)}
                </div>
                <div className="status-item" title={`Ollama: ${status.ollama}`}>
                    <span className="status-label">Ollama</span>
                    {getStatusIcon(status.ollama)}
                </div>
            </div>
        </div>
    );
}
